// extracted by mini-css-extract-plugin
export default {"collaboration":"_3Bw9lov42i1ay4kGbjp-Hg","content":"_39M72ZtbJq08WY-GD_0mAw","contentStudent":"_2-4Du0qw8D6Pvu5SxLd3fP"};